import React from 'react';

import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  WysiwygField,
} from '../../../components';

import './style.scss';

const ParagraphText = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_text', 0, 'processed'], '');
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  return (
    <Container className="ParagraphText" small>
      {title && <h2 className="Text__title">{title}</h2>}
      <WysiwygField
        property="schema:text"
        className="Text__body"
        html={body}
      />
      {linkHref && linkTitle && (
        <Button className="ParagraphText__button" inverted href={linkHref}>{linkTitle}</Button>
      )}
    </Container>
  );
};

export default ParagraphText;
